import styled from 'styled-components'

import COLORS from '@colors'

export const Button = styled.button`
  border: 0;
  background-color: transparent;
  color: ${COLORS.gray28};
  cursor: pointer;
  outline: 0;
  font-size: 24px;

  :hover {
    background-color: ${({ noHover }) => !noHover && COLORS.grayE};
  }

  i {
    font-size: 20px;
    display: inline-block;
    vertical-align: sub;
  }
`

export const DropDown = styled.div`
  position: absolute;
  will-change: transform;
  background-color: ${COLORS.white};
  box-shadow: 0px 3px 6px #00000029;
  margin-top: 5px;
  z-index: 1;
  right: 0;
  left: ${props => (props.right ? '0' : 'unset')};
  width: ${({ dropdownContainerWidth }) =>
    dropdownContainerWidth ? dropdownContainerWidth : '248px'};
  display: ${props => (props.visible ? 'block' : 'none')};
`

export const Option = styled.div`
  cursor: pointer;
  color: ${COLORS.gray28};
  padding: 13px 16px;
  font-size: 14px;
  height: 38px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 17px;
  }

  &:hover {
    background-color: #f3ede1;
  }
`
